/* eslint-disable */
import { Unsubscribe } from "redux";

import { watch, watchDetail } from "~/state/util";
import DataProvider from "../data-provider";
import { store } from "~/state/store";
import SceneLayerMarker from "~/scene/layer/marker";
import SceneMarkerWindyWebcam from "~/scene/marker/windy-webcam";
import Scene from "~/scene";
import { IPoi } from "~/interfaces";

export default class FotoWCamDataProvider extends DataProvider {
	_storeUnsubscribe: Unsubscribe;

	_layerMarker: SceneLayerMarker;

	_detailLayerMarker: SceneLayerMarker;

	_savedMarker: any;

	_detailMarker: any;

	constructor() {
		super();

		const watcher = watch(store.getState, "detail", watchDetail);

		this._storeUnsubscribe = store.subscribe(watcher((newDetail, oldDetail) => {
			if (newDetail.data && oldDetail.data === null) {
				if (newDetail.data.source === "wcam") {
					this._activateDetail(newDetail.data);
				} else {
					this._deactivateDetail();
				}
			} else if (newDetail.data === null && oldDetail.data) {
				this._deactivateDetail();
			}
		}));
		this._layerMarker = null;
		this._detailLayerMarker = null;
		this._savedMarker = null;
		this._detailMarker = null;
	}

	destroy() {
		this._storeUnsubscribe();
		Scene.removeLayer(this._detailLayerMarker).disable();
	}

	override enable(): this {
		if (!this._active) {
			this._active = true;
			this._layers.forEach(layer => layer.enable());
		}

		this._request(false);

		return this;
	}

	override disable(): this {
		this._layers.forEach(layer => layer.removeAll());

		return super.disable();
	}

	addCustomLayers({
		layerMarker,
		detailLayerMarker,
	}: {
		layerMarker: SceneLayerMarker;
		detailLayerMarker: SceneLayerMarker;
	}) {
		this._layerMarker = layerMarker;
		this._detailLayerMarker = detailLayerMarker;

		// pridame vrstvu pro detail & povolime
		Scene.addLayer(this._detailLayerMarker).enable();
	}

	override _done() {
		super._done();

		const detailData = store.getState().detail;

		if (detailData.data?.source === "wcam") {
			this._activateDetail(detailData.data);
		} else {
			this._deactivateDetail();
		}
	}

	_activateDetail(detailData: IPoi) {
		if (!this._savedMarker) {
			const findMarker = this._layerMarker.getMarkers().filter(marker => marker instanceof SceneMarkerWindyWebcam).filter(marker => marker.getPlainId() === detailData.id);

			if (findMarker.length === 1) {
				this._savedMarker = findMarker[0];
				this._layerMarker.removeMarker(this._savedMarker);
			}
		}

		// vytvorime marker
		if (!this._detailMarker) {
			this._detailMarker = Scene.createMarkerWindyWebcamFromData({
				geomInLookup: false,
				id: detailData.id,
				mark: detailData.mark,
				markCamera: detailData.mark,
				markOrigin: detailData.mark,
				source: detailData.source,
				title: detailData.title,
				url: detailData.extend.webcamData.preview,
				zoom: 1,
			});
			this._detailMarker.setActive(true, false);
			this._detailLayerMarker.addMarker(this._detailMarker);
		}
	}

	_deactivateDetail() {
		if (this._savedMarker) {
			this._layerMarker.addMarker(this._savedMarker);
			this._savedMarker = null;
		}

		if (this._detailMarker) {
			this._detailLayerMarker.removeMarker(this._detailMarker);
			this._detailMarker = null;
		}
	}
}
